import axios from "axios";
import { LOGIN_API_URL } from "../constants";

export const authenticateWithMicrosoft = async ({ code, codeVerifier }) => {
  try {
    const response = await axios.post(
      `${LOGIN_API_URL}/oauth2/microsoft-auth`,
      {
        code,
        code_verifier: codeVerifier,
      },
      {
        withCredentials: true,
      },
    )

    return response.data;
  } catch (error) {
    console.error("Microsoft authentication error:", error);
    throw error;
  }
};

